export const IMAGE_MIME_TYPES = ["image/jpeg", "image/png"];

export const TEXT_MIME_TYPES = ["text/plain", "text/csv", "text/markdown"];

const DOCUMENT_MIME_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const ACCEPTED_MIME_TYPES = new Set([
  ...TEXT_MIME_TYPES,
  ...IMAGE_MIME_TYPES,
  ...DOCUMENT_MIME_TYPES,
]);

export const ACCEPTED_FILE_TYPES = Array.from(ACCEPTED_MIME_TYPES).join(",");

export const MAX_ATTACHMENTS = 10;

export const MAX_FILE_SIZE_MB = 30;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

export const AVATAR_MAX_FILE_SIZE_MB = 5;
